import axios from 'axios';

export default {
  selectors: (params = {}, config = {}) => axios.get('reports/sales/selectors', { params, ...config }),
  metrics: (params = {}, config = {}) => axios.get('reports/sales/metrics', { params, ...config }),
  table: (params = {}, config = {}) => axios.get('reports/sales/table', { params, ...config }),
  detail: (params = {}, config = {}) => axios.get('reports/sales/detail', { params, ...config }),
  excel: (params = {}, config = {}) => axios.get('reports/sales/excel', {
    params,
    responseType: 'blob',
    ...config,
  }),
  pdf: (params = {}, config = {}) => axios.get('reports/sales/pdf', {
    params,
    responseType: 'blob',
    ...config,
  }),
};
